import React from 'react';
import { CheckIcon, FileTextIcon, CameraIcon, HourglassIcon, ArrowRightIcon, LayoutDashboardIcon, FileStackIcon, ClipboardCheckIcon, CreditCardIcon, FolderIcon, BarChart3Icon, CalendarIcon, ChevronDownIcon, XIcon, LeafIcon, InboxIcon, ClockIcon } from 'lucide-react';
import { phoneCopy, dashboardCopy, type Bi } from '../../data/permisHero';
import { GreenCheck } from './PermisCards';
type P = {
  isFR: boolean;
};
const pk = (isFR: boolean) => (v: Bi) => isFR ? v.fr : v.en;
export function PermisPhone({
  isFR
}: P) {
  const pick = pk(isFR);
  const active = phoneCopy.activeStep;
  return <div className="w-[300px] rounded-[44px] bg-[#16171D] p-[9px] shadow-[0_40px_70px_-30px_rgba(20,20,60,0.6)]" data-id="element-4947" data-mp="21x4rsrzndv9w">
      <div className="relative rounded-[36px] bg-white overflow-hidden" data-id="element-4948" data-mp="1wz39i9a1pzzh">
        <div className="absolute left-1/2 top-2 -translate-x-1/2 w-[92px] h-[26px] rounded-full bg-[#16171D]" aria-hidden="true" data-id="element-4949" data-mp="1rx446tuqwszw" />
        <div className="flex items-center justify-between px-6 pt-3.5 font-sans text-[11px] font-semibold text-[#121212]" data-id="element-4950" data-mp="1nxdektgygiwy">
          <span data-id="element-4951" data-mp="nirw0pp0g8n9">9:41</span>
          <span className="flex gap-1" aria-hidden="true" data-id="element-4952" data-mp="nj1l8b28ebrw">
            <span className="w-3.5 h-2 rounded-sm bg-[#121212]" data-id="element-4953" data-mp="nkl489f9v0xd" />
            <span className="w-5 h-2 rounded-sm bg-[#121212]" data-id="element-4954" data-mp="8vgk2mox2mmm" />
          </span>
        </div>
        <div className="px-4 pt-7 pb-4" data-id="element-4955" data-mp="dtqhl3y45zbe">
          <p className="font-sans text-[16px] font-semibold text-[#121A3A]" data-id="element-4956" data-mp="dqm23af77h5f">{pick(phoneCopy.title)}</p>

          <ol className="mt-4 grid grid-cols-4 relative" data-id="element-4957" data-mp="16hm97u8tt11b">
            <span className="absolute left-[12%] right-[12%] top-[11px] h-[2px] bg-[#E6E7EF]" aria-hidden="true" data-id="element-4958" data-mp="16h45kcju3kjd" />
            <span className="absolute left-[12%] top-[11px] h-[2px] bg-[#4F46E5]" style={{
            width: `${active / 3 * 76}%`
          }} aria-hidden="true" data-id="element-4959" data-mp="shl6e9903jj7" />
            {phoneCopy.steps.map((s, i) => <li key={i} className="relative flex flex-col items-center gap-1" data-id="element-4960" data-mp="3d6sh73gsvmtf" data-mpi={i}>
                <span className={`w-6 h-6 rounded-full flex items-center justify-center font-sans text-[10px] font-semibold ${i < active ? 'bg-[#4F46E5] text-white' : i === active ? 'bg-[#4F46E5] text-white ring-4 ring-[#4F46E5]/15' : 'bg-[#F1F2F6] text-[#5B6478]'}`} data-id="element-4961" data-mp="3hagp5n9cgkf7">
                  {i < active ? <CheckIcon className="w-3.5 h-3.5" strokeWidth={3} data-id="element-4962" data-mp="192bubgf9nbuu" /> : i + 1}
                </span>
                <span className={`font-sans text-[8.5px] ${i === active ? 'text-[#4F46E5] font-semibold' : 'text-[#6B7180]'}`} data-id="element-4963" data-mp="15071ul0k0l9s">{pick(s)}</span>
              </li>)}
          </ol>

          <div className="mt-4 rounded-2xl border border-[#EEEEF4] p-3" data-id="element-4964" data-mp="v2as9xn9lyds">
            <p className="flex items-center justify-between" data-id="element-4965" data-mp="v4dl0pfsy5m7">
              <span className="font-sans text-[12px] font-semibold text-[#121A3A]" data-id="element-4966" data-mp="q49adg1ks53w">{pick(phoneCopy.docsTitle)}</span>
              <span className="font-sans text-[9px] text-[#6B7180]" data-id="element-4967" data-mp="2pfscpbsdif4l">{pick(phoneCopy.docsCount)}</span>
            </p>
            <ul className="mt-2 divide-y divide-[#F0F0F5]" data-id="element-4968" data-mp="2kf4jqkkl3o7q">
              {phoneCopy.docs.map((d, i) => {
              const Icon = d.kind === 'photo' ? CameraIcon : FileTextIcon;
              return <li key={i} className="flex items-center gap-2.5 py-2" data-id="element-4969" data-mp="2wxgqdc2twou7" data-mpi={i}>
                    <span className="w-7 h-7 rounded-lg bg-[#E9F6EE] flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-4970" data-mp="31rbh2zguq42s">
                      <Icon className="w-3.5 h-3.5 text-[#22A04F]" strokeWidth={2} data-id="element-4971" data-mp="29zdjf2nz3ykl" />
                    </span>
                    <span className="flex-1 min-w-0" data-id="element-4972" data-mp="2e0pdbkdvr5yl">
                      <span className="block font-sans text-[10.5px] font-medium text-[#121A3A]" data-id="element-4973" data-mp="2e18rqr4bnc7v">{pick(d.name)}</span>
                      <span className="block font-sans text-[9px] text-[#8A90A2]" data-id="element-4974" data-mp="2j2elms9px5iz">{pick(d.meta)}</span>
                    </span>
                    <GreenCheck size={15} data-id="element-4975" data-mp="3ufqkeoqmexya" />
                  </li>;
            })}
              <li className="flex items-center gap-2.5 py-2" data-id="element-4976" data-mp="38ebewzw5qtg">
                <span className="w-7 h-7 rounded-lg bg-[#F1F0FD] flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-4977" data-mp="3b0i6ueyk2am">
                  <HourglassIcon className="w-3.5 h-3.5 text-[#4F46E5]" strokeWidth={2} data-id="element-4978" data-mp="17718f90koxm4" />
                </span>
                <span className="flex-1 min-w-0" data-id="element-4979" data-mp="1l6stftpibe9m">
                  <span className="block font-sans text-[10.5px] font-medium text-[#121A3A]" data-id="element-4980" data-mp="1l4g0ymm4hlib">{pick(phoneCopy.pending.name)}</span>
                  <span className="block font-sans text-[9px] text-[#8A90A2]" data-id="element-4981" data-mp="1v4gokkr0ynsb">{pick(phoneCopy.pending.meta)}</span>
                </span>
              </li>
            </ul>
          </div>

          <span className="mt-3.5 flex items-center justify-center gap-2 rounded-xl bg-[#4F46E5] py-3 font-sans text-[12px] font-semibold text-white" data-id="element-4982" data-mp="23x0rhxecneiy">
            {pick(phoneCopy.submit)}
            <ArrowRightIcon className="w-3.5 h-3.5" strokeWidth={2.2} aria-hidden="true" data-id="element-4983" data-mp="1zxszxt6p0y34" />
          </span>
        </div>
      </div>
    </div>;
}
const NAV_ICONS = [LayoutDashboardIcon, FileStackIcon, ClipboardCheckIcon, CreditCardIcon, FolderIcon, BarChart3Icon];
const KPI_ICONS = [InboxIcon, FileStackIcon, ClockIcon];
export function PermisDashboard({
  isFR
}: P) {
  const pick = pk(isFR);
  const d = dashboardCopy;
  return <div className="rounded-[26px] bg-[#1B1D24] p-[8px] shadow-[0_40px_80px_-40px_rgba(20,20,60,0.55)]" data-id="element-4984" data-mp="2ik8vad5bwhkw">
      <div className="rounded-[20px] bg-white overflow-hidden flex min-h-[360px]" data-id="element-4985" data-mp="2nianbnkqfr8i">
        <aside className="hidden sm:block w-[128px] shrink-0 border-r border-[#F0F0F5] bg-[#FAFAFD] px-2.5 py-3.5" data-id="element-4986" data-mp="29rp41xrd9fa3">
          <p className="flex items-center gap-1.5 px-1.5 font-sans text-[11px] font-semibold text-[#121A3A]" data-id="element-4987" data-mp="2eidvjd31qc98">
            <span className="w-5 h-5 rounded-md bg-[#22A04F] flex items-center justify-center" aria-hidden="true" data-id="element-4988" data-mp="1zuanly5g0qhs">
              <LeafIcon className="w-3 h-3 text-white" strokeWidth={2.2} data-id="element-4989" data-mp="24suca6bf8gdu" />
            </span>
            {d.city}
          </p>
          <ul className="mt-4 space-y-1" data-id="element-4990" data-mp="1qunvy42imz1x">
            {d.nav.map((n, i) => {
            const Icon = NAV_ICONS[i];
            const on = i === 1;
            return <li key={i} className={`flex items-center gap-1.5 rounded-md px-1.5 py-1.5 font-sans text-[8.5px] ${on ? 'bg-[#1B1E3A] text-white font-semibold' : 'text-[#5B6478]'}`} data-id="element-4991" data-mp="1d0l9df7fdrb" data-mpi={i}>
                  <Icon className="w-3 h-3 shrink-0" strokeWidth={2} aria-hidden="true" data-id="element-4992" data-mp="3irxlmygj18nx" />
                  <span className="truncate" data-id="element-4993" data-mp="3iq2zjgtirai9">{pick(n)}</span>
                </li>;
          })}
          </ul>
        </aside>
        <div className="flex-1 min-w-0 p-3.5" data-id="element-4994" data-mp="faxhg8pqxi5g">
          <div className="flex items-center justify-between gap-2" data-id="element-4995" data-mp="f9464g46u9r4">
            <p className="font-sans text-[13px] font-semibold text-[#121A3A]" data-id="element-4996" data-mp="aaswa5dw7z8w">{pick(d.title)}</p>
            <span className="flex items-center gap-1 rounded-md border border-[#EEEEF4] px-2 py-1 font-sans text-[8.5px] text-[#3A4050]" data-id="element-4997" data-mp="69qylszmjv91">
              <CalendarIcon className="w-2.5 h-2.5" aria-hidden="true" data-id="element-4998" data-mp="2v008n41ccal8" />
              {pick(d.period)}
              <ChevronDownIcon className="w-2.5 h-2.5" aria-hidden="true" data-id="element-4999" data-mp="2r342arutvfa4" />
            </span>
          </div>
          <ul className="mt-3 grid grid-cols-3 gap-2" data-id="element-5000" data-mp="1akakbghq807s">
            {d.kpis.map((k, i) => {
            const Icon = KPI_ICONS[i];
            return <li key={i} className="rounded-xl border border-[#EEEEF4] px-2.5 py-2" data-id="element-5001" data-mp="1fhu4ex13v77n" data-mpi={i}>
                  <p className="flex items-center gap-1 font-sans text-[8px] text-[#6B7180]" data-id="element-5002" data-mp="1kavmtf0itovz">
                    <Icon className="w-2.5 h-2.5 text-[#4F46E5]" aria-hidden="true" data-id="element-5003" data-mp="1p8f3smolsfrm" />
                    {pick(k.label)}
                  </p>
                  <p className="mt-1 flex items-baseline gap-1.5 flex-wrap" data-id="element-5004" data-mp="1ua4d9xw6gldl">
                    <span className="font-sans text-[17px] font-semibold text-[#121A3A] leading-none" data-id="element-5005" data-mp="1yaofhfvlyf6l">
                      {typeof k.value === 'string' ? k.value : pick(k.value)}
                    </span>
                    {k.trend && <span className="font-sans text-[9.5px] font-semibold text-[#1E8A45]" data-id="element-5006" data-mp="3y86467imkxi">{pick(k.trend)}</span>}
                  </p>
                </li>;
          })}
          </ul>
          <div className="mt-3 rounded-xl border border-[#EEEEF4] px-3 py-2.5" data-id="element-5007" data-mp="2aq4iq3j8jyx8">
            <div className="flex items-center justify-between" data-id="element-5008" data-mp="26qnefdfjp7tn">
              <ul className="flex gap-4" data-id="element-5009" data-mp="2kh8y34ctplsl">
                {d.tabs.map((t, i) => <li key={i} className={`font-sans text-[9px] pb-1 ${i === 0 ? 'text-[#121A3A] font-semibold border-b-2 border-[#4F46E5]' : 'text-[#6B7180]'}`} data-id="element-5010" data-mp="2fixmop6vr389" data-mpi={i}>
                    {pick(t)}
                  </li>)}
              </ul>
              <XIcon className="w-3 h-3 text-[#9A9FB5]" aria-hidden="true" data-id="element-5011" data-mp="21su6aeuom3qq" />
            </div>
            <ul className="mt-2.5 space-y-2" data-id="element-5012" data-mp="1wsg6tl75c24b">
              {d.stages.map((s, i) => <li key={i} className="grid grid-cols-[minmax(0,1.3fr)_minmax(0,1fr)_28px_18px] items-center gap-2" data-id="element-5013" data-mp="3d6g40oelxdnv" data-mpi={i}>
                  <span className="flex items-center gap-1.5 font-sans text-[8.5px] text-[#3A4050] min-w-0" data-id="element-5014" data-mp="386tilromkr3z">
                    <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{
                  background: s.dot
                }} aria-hidden="true" data-id="element-5015" data-mp="tzc62xctxxnh" />
                    <span className="truncate" data-id="element-5016" data-mp="yx3uhhe9n1mx">{pick(s.label)}</span>
                  </span>
                  <span className="h-1.5 rounded-full bg-[#EEF0F6] overflow-hidden" data-id="element-5017" data-mp="l19u5mrk5klf">
                    <span className="block h-full rounded-full bg-[#4F46E5]" style={{
                  width: `${s.pct}%`
                }} data-id="element-5018" data-mp="pz1yjg9e2z6i" />
                  </span>
                  <span className="font-sans text-[8.5px] text-[#6B7180] text-right" data-id="element-5019" data-mp="1dqgvetiecoad">{s.pct}{isFR ? ' %' : '%'}</span>
                  <span className="font-sans text-[8.5px] text-[#6B7180] text-right" data-id="element-5020" data-mp="13yjed64pj23q">{s.count}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </div>;
}